<app-header *ngIf="!hideExternalHeader && viewComponent"></app-header>
<router-outlet></router-outlet>
<app-footer *ngIf="!hideExternalFooter"></app-footer>
<app-bottom-navigation class="fixed-bottom" *ngIf="!hideBottom && viewComponent && showBottom"></app-bottom-navigation>